import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import InternalReview from '../review/InternalReview'
import QualityReview from '../review/QualityReview'

import {
  userCanViewInternalReviewInfo,
  questIsInDraftState
} from '../../../utils/review'
import { questIsAssignedToUser } from '../../../utils/assignment'
import { currentReviewsFilteredForQuestState } from '../../../selectors/review'

class QuestReview extends Component {
  render() {
    const { user, quest } = this.props

    return (
      <div className="review-section">
        <InternalReview
          userCanViewInternalReviewInfo={userCanViewInternalReviewInfo(
            user,
            quest
          )}
          questIsInDraftState={questIsInDraftState(quest)}
          questIsAssignedToUser={questIsAssignedToUser(quest, user)}
          {...this.props}
        />
        <div className="divider-container">
          <div className="bottom-white-bar" />
          <div className="grey-divider" />
          <div className="top-black-bar" />
        </div>
        <QualityReview {...this.props} />
      </div>
    )
  }
}

QuestReview.propTypes = {
  quest: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  currentReviews: PropTypes.array.isRequired,
  isFetchingCompiledQuest: PropTypes.bool,
  isFetchingQuest: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  previousReviews: PropTypes.array.isRequired,
  organization: PropTypes.object.isRequired,
  handleAssignClick: PropTypes.func.isRequired,
  approvals: PropTypes.array,
  toQualityReviewModalIsOpen: PropTypes.bool.isRequired,
  isEditingApproval: PropTypes.bool.isRequired,
  isSettingLastApproval: PropTypes.bool.isRequired,
  activities: PropTypes.array.isRequired
}

export const mapStateToProps = state => ({
  quest: state.quest.item,
  user: state.user.user,
  currentReviews: currentReviewsFilteredForQuestState(state),
  isFetchingCompiledQuest: state.quest.isFetchingCompiledQuest,
  isFetchingQuest: state.quest.isFetchingQuest,
  previousReviews: state.quest.previousReviews,
  organization: state.organization,
  approvals: state.quest.approvals,
  toQualityReviewModalIsOpen: state.quest.toQualityReviewModalIsOpen,
  isEditingApproval: state.quest.isEditingApproval,
  isSettingLastApproval: state.quest.isSettingLastApproval,
  activities: state.quest.activities
})

export default connect(mapStateToProps)(QuestReview)
export { QuestReview as QuestReviewDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/section/QuestReview.js